import { Type } from '../../../../../redux/Transaction/helper';
import { SubscriptionScopeKey } from './SubscriptionScopeKey';

export const SubscriptionScopeKeysByType = {
    [Type.sale_invoice]: SubscriptionScopeKey.SALE,
    [Type.sale_credit_note]: SubscriptionScopeKey.SALE,
    [Type.opening_invoice]: SubscriptionScopeKey.SALE,
    [Type.sale_delivery_note]: SubscriptionScopeKey.SALE,
    [Type.opening_sale_credit_note]: SubscriptionScopeKey.SALE,
    [Type.sale_order]: SubscriptionScopeKey.SALE,
    [Type.sale_delivery_order]: SubscriptionScopeKey.SALE,
    [Type.sale_payment]: SubscriptionScopeKey.SALE,
    [Type.sale_refund]: SubscriptionScopeKey.SALE,
    [Type.sale_quote]: SubscriptionScopeKey.SALE,

    [Type.purchase_order]: SubscriptionScopeKey.PURCHASE,
    [Type.purchase_goods_received_note]: SubscriptionScopeKey.PURCHASE,
    [Type.purchase_bill]: SubscriptionScopeKey.PURCHASE,
    [Type.purchase_bill_cash]: SubscriptionScopeKey.PURCHASE,
    [Type.purchase_bill_claim]: SubscriptionScopeKey.PURCHASE,
    [Type.purchase_credit_note]: SubscriptionScopeKey.PURCHASE,
    [Type.purchase_payment]: SubscriptionScopeKey.PURCHASE,
    [Type.purchase_refund]: SubscriptionScopeKey.PURCHASE,
    [Type.opening_bill]: SubscriptionScopeKey.PURCHASE,
    [Type.opening_purchase_credit_note]: SubscriptionScopeKey.PURCHASE,

    [Type.bank_income]: SubscriptionScopeKey['BANK.TRANSACTION'],
    [Type.bank_expense]: SubscriptionScopeKey['BANK.TRANSACTION'],
    [Type.bank_transfer]: SubscriptionScopeKey['BANK.TRANSACTION'],

    [Type.stock_adjustment]: SubscriptionScopeKey['INVENTORY.STOCK_ADJUSTMENT'],
    [Type.stock_transfer]: SubscriptionScopeKey['INVENTORY.STOCK_TRANSFER'],
    [Type.tax_deemed_payment]: SubscriptionScopeKey['TAX.SST'],

    [Type.journal_entry]: SubscriptionScopeKey['ACCOUNTING.JOURNAL_ENTRY'],
    [Type.contra]: SubscriptionScopeKey['ACCOUNTING.CONTRA'],
    [Type.fixed_asset]: SubscriptionScopeKey['ACCOUNTING.FIXED_ASSET'],

    [Type.statement]: SubscriptionScopeKey['CONTACT.STATEMENT'],
    [Type.store_order]: SubscriptionScopeKey.STORE,
};
